import { InferGetStaticPropsType } from "next";
import axios from "axios";
import { NextSeo } from "next-seo";
import Footer from "@/components/Footer";
import MamapediaHome from "@/components/Mamapedia/Homepage";
import MamapediaHeader from "@/components/Header/MamapediaHeader";



const MamapediaHomepage = ({
  homepage,
}: InferGetStaticPropsType<typeof getStaticProps>) => {

  return (
    <>
      <NextSeo
        title=''
        defaultTitle='MOOIMOM Mamapedia'
        canonical={process.env.NEXT_PUBLIC_HOSTNAME}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/mamapedia-mb-new.png",
            width: 500,
            height: 150,
            alt: 'MOOIMOM Mamapedia image',
          }]
        }}
      />
      <MamapediaHeader />
      <MamapediaHome homepage={homepage} />
      <Footer />
    </>
  )
}

export default MamapediaHomepage

export const getStaticProps = async () => {
  const response = await axios.get(
    process.env.NEXT_PUBLIC_API_URL! + process.env.NEXT_PUBLIC_API_MAMAPEDIA_HOMEPAGE!
  );

  return {
    props: { homepage: response.data },
    revalidate: 3600,
  }
}
